import { getMediaUrl } from 'utils/assets';
import useLayout from 'utils/layout';

import styles from './AuthStaticBlockFallback.module.scss';

const AuthStaticBlockFallback = () => {
  const layout = useLayout();

  return (
    <div
      className={styles[layout]}
      style={{
        background: `url(${getMediaUrl('yellow/auth-placeholder.webp')}) center / 100% repeat`,
      }}
    />
  );
};

export default AuthStaticBlockFallback;
